var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 3.4468C0 1.68419 1.34315 0.25531 3 0.25531H19C20.6569 0.25531 22 1.68419 22 3.4468V14.0851C22 15.8477 20.6569 17.2766 19 17.2766H3C1.34315 17.2766 0 15.8477 0 14.0851V3.4468ZM3 2.38297C2.44772 2.38297 2 2.85926 2 3.4468V14.0851C2 14.6726 2.44772 15.1489 3 15.1489H19C19.5523 15.1489 20 14.6726 20 14.0851V3.4468C20 2.85926 19.5523 2.38297 19 2.38297H3Z",
    fill: "#000000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.0006 2.83785L20.69 3.15288C20.6572 3.1862 20.6223 3.2171 20.5855 3.24536L11.5855 10.1603C11.236 10.4288 10.764 10.4288 10.4145 10.1603L1.41449 3.24536C1.35889 3.20265 1.30758 3.15396 1.26135 3.10008L0.991089 2.78505L2.46835 1.35078L2.66908 1.58476L11 7.98556L19.3592 1.56296L19.6205 1.29797L21.0006 2.83785Z",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.40f907cbc2225be4816bda3dee6c3204.svg";
export { ForwardRef as ReactComponent };